
import Popup from 'vux/src/components/popup/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

export default {
components: {Popup, Group, Cell},
name: 'patCaseInfo',
props: {
infoList: {
type: Map
}
},
data () {
return {
lists: []
}
},
watch: {
infoList: function (val, oldVal) {

this.lists = [
{title: '名称:', value: this.infoList.get('caseName')},
{title: '姓名:', value: this.infoList.get('patName')},
{title: '性别:', value: this.infoList.get('patSex')},
{title: '年龄:', value: this.infoList.get('patAge')},
{title: '样本号:', value: this.infoList.get('patHologyId')},
{title: '疑难病例:', value: this.infoList.get('isDifficult') === 0 ? '否' : '是'},
{title: '病史:', value: this.infoList.get('medicalHistory')},
{title: '临床诊断:', value: this.infoList.get('clinicalDiagonse')}
]
}
},
mounted () {

}
}



// WEBPACK FOOTER //
// ./src/components/doctor/diagnosis/patCaseInfo.vue